import React, { useState, useEffect } from 'react'
import { PageHeader, Button, Table, Skeleton, Popconfirm, Modal } from 'antd'
import { useQuery } from '@apollo/react-hooks'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'

import ResultError from '@packages/ResultError'
import { GOALS_ICON } from '@constants/IconsConstants'
import { useColumnFilterProps } from '@utils/columnFilter'
import { getGoalsQuery } from '@graphql/queries'
import { useUpdateGoal, useDeleteGoal } from '@graphql/mutations'

import EditableCell from '../../EditableCell'
import ManageGoalForm from '../ManageGoalForm'

const tableProps = {
  size: 'middle',
  pagination: false,
}
const newButtonProps = {
  type: 'primary',
  icon: <PlusOutlined />,
  key: 'new',
}

function ManageGoalTable() {
  const [tableData, setTableData] = useState(false)
  const [formModalVisible, setFormModalVisible] = useState(false)
  const { error, data } = useQuery(getGoalsQuery)
  const [update] = useUpdateGoal()
  const [deleteRecord] = useDeleteGoal()
  const useFilterField = field => useColumnFilterProps(field)
  const toggleFormModal = () => setFormModalVisible(!formModalVisible)

  useEffect(() => {
    if (data) setTableData(data.goals)
  }, [data])

  const handleSave = data => {
    const { id, name } = data
    const newData = [...tableData]
    const index = newData.findIndex(item => item.id === data.id)
    const item = newData[index]

    newData.splice(index, 1, { ...item, ...data })

    if (JSON.stringify(newData) !== JSON.stringify(tableData)) {
      update({
        variables: {
          id,
          data: {
            name: { set: name },
          },
        },
      })

      setTableData(newData)
    }
  }

  const handleDelete = id => {
    deleteRecord({
      variables: { id },
      refetchQueries: ['GetGoalsQuery'],
    })
  }
  const columns = [
    {
      dataIndex: 'name',
      title: 'Nome',
      editable: true,
      ...useFilterField('name'),
    },
    {
      align: 'center',
      render: (value, { id, name }) => (
        <Popconfirm
          title={`Tem a certeza que quer eliminar ${name} ?`}
          onConfirm={() => handleDelete(id)}
          okText="Sim"
          cancelText="Não"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ]
  const mappedColumns = columns.map(col => {
    if (!col.editable) return col

    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })

  return (
    <>
      <Modal
        title="Nova finalidade"
        visible={formModalVisible}
        onCancel={() => toggleFormModal()}
        footer={null}
      >
        <ManageGoalForm afterSubmit={() => toggleFormModal()} />
      </Modal>

      <PageHeader
        title="Finalidades"
        avatar={{ src: GOALS_ICON }}
        extra={[
          <Button {...newButtonProps} onClick={() => toggleFormModal()}>
            Nova finalidade
          </Button>,
        ]}
      />

      {error && <ResultError />}

      <Skeleton loading={!error && !tableData} active>
        {tableData && (
          <Table
            components={EditableCell.Components}
            columns={mappedColumns}
            dataSource={tableData}
            rowKey={({ id }) => id}
            rowClassName={() => 'editable-row'}
            {...tableProps}
          />
        )}
      </Skeleton>
    </>
  )
}

export default ManageGoalTable
